import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  ThemeProvider,
  Typography,
  createTheme,
  Box,
  useMediaQuery,
} from "@mui/material";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const MicAccessPopup = () => {
  const [open, setOpen] = useState(false);
  const isPhone = useMediaQuery("(max-width:600px)");
  const isLandscape = useMediaQuery("(orientation: landscape)");
  const dialogWidth = isPhone
    ? isLandscape
      ? "76vw"
      : "92vw"
    : "400px";
  const dialogMargin = isPhone ? "12px auto" : "150px";


  // Check microphone permission on component mount
  useEffect(() => {
    const checkPermission = async () => {
      if (navigator.permissions) {
        try {
          const permissionStatus = await navigator.permissions.query({
            name: "microphone",
          });
          if (permissionStatus.state !== "granted") {
            setOpen(true);
          }
          // Listen for changes in permission state
          permissionStatus.onchange = () => {
            if (permissionStatus.state === "granted") {
              setOpen(false);
            }
          };
        } catch (error) {
          console.error("Error checking microphone permission:", error);
          // Fallback to showing the popup if an error occurs
          setOpen(true);
        }
      } else {
        // If Permissions API is not supported, show the popup by default.
        setOpen(true);
      }
    };

    checkPermission();
  }, []);

  // Function to request microphone access
  const handleRequestMicAccess = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      setOpen(false);
      // Additional logic can be added here if needed
    } catch (error) {
      console.error("Error accessing the microphone:", error);
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Dialog
        open={open}
        fullWidth
        maxWidth="sm"
        sx={{
          "& .MuiDialog-container": {
            alignItems: isPhone && isLandscape ? "flex-start" : "center", // Positions the dialog closer to the bottom
            padding: isPhone ? "12px" : undefined, // keep desktop default spacing
          },
        }}
        PaperProps={{
          sx: isPhone
            ? {
                width: dialogWidth,
                maxWidth: dialogWidth,
                margin: dialogMargin,
                borderRadius: 2,
                px: "var(--dialog-padding, 24px)",
                py: 2,
              }
            : {
                width: "400px",
                maxWidth: "400px",
                margin: "150px",
              },
        }}
      >
        <DialogTitle>Turn on mic to use 10k Science</DialogTitle>
        <DialogContent>
          <Typography>
            You will be able to answer questions and get feedback during your
            experience.
          </Typography>
          <Box mt={2}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleRequestMicAccess}
            >
              Turn on microphone
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

     
    </ThemeProvider>
  );
};

export default MicAccessPopup;
